import http from '@/utils/http';
const base_path = '/v2/tool/unionPackage';

/**
 * 获取联盟流量包接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const getUnionPackageApi = (params) => {
  return http.get({
    url: base_path,
    params,
  });
};
